import {useIntl} from 'react-intl'

export default function BreadCrumb({
  parentPage,
  currentPage,
}: {
  parentPage?: string
  currentPage: string
}) {
  const intl = useIntl()

  return (
    <div className='page-title d-flex flex-column justify-content-center gap-1 me-3'>
      <h1 className='page-heading d-flex flex-column justify-content-center text-dark fw-bold fs-3 m-0'>
        {currentPage}
      </h1>
      <ul className='breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0'>
        <li className='breadcrumb-item text-muted'>
          <a href='/dashboard' className='text-muted text-hover-primary'>
            {/* Home */}
            {intl.formatMessage({id: 'MENU.HOME'})}
          </a>
        </li>
        <li className='breadcrumb-item'>
          <span className='bullet bg-gray-400 w-5px h-2px'></span>
        </li>
        <li className='breadcrumb-item text-muted'>{intl.formatMessage({id: 'APP_NAME'})}</li>
        <li className='breadcrumb-item'>
          <span className='bullet bg-gray-400 w-5px h-2px'></span>
        </li>
        {parentPage && (
          <>
            <li className='breadcrumb-item text-muted'>{parentPage}</li>
            <li className='breadcrumb-item'>
              <span className='bullet bg-gray-400 w-5px h-2px'></span>
            </li>
          </>
        )}
        <li className='breadcrumb-item text-dark'>{currentPage}</li>
      </ul>
    </div>
  )
}
